var map = {
	"./costal-1-5.jpg": "33cd",
	"./costal-2-5.jpg": "b1fb",
	"./costal-3-5.jpg": "a115",
	"./costal-4-5.jpg": "7ba8",
	"./costal-5-5.jpg": "525a",
	"./costal-6-5.jpg": "8dee",
	"./costal-7-5.jpg": "8f28",
	"./costal-8-5.jpg": "f269"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7dd";